export const API_URL = "https://prod.malllogisticsapi.com/api/";